export enum SulaHubNotificationType {
    NewUserRequest = 0,
    UserRequestApproved = 1,
    UserRequestReproved = 2,
    UserUpdateRequest = 3,
    UserUpdateRequestApproved = 4,
    UserUpdateRequestReproved = 5,
}

export enum SmartCargasNotificationType {
    Custom = 0,
    LoadConfirmed = 1,
    LoadCanceled = 2,
    NewAcceptanceRound = 3,
    NewConfirmationRound = 4,
}

export type INotificationType =
    | SulaHubNotificationType
    | SmartCargasNotificationType;
